import React from "react";
import { twMerge } from "tailwind-merge";
import { Store } from "../storeType";
import formatStoreHours from "../utils/formatStoreHours";
import getCurrentDayName from "../utils/getCurrentDayName";
import { SPSection } from ".";

interface SPHoursSectionProps {
  store: Store;
}

const SPHoursSection = ({ store }: SPHoursSectionProps) => {
  const currentDayName = getCurrentDayName();

  return (
    <SPSection headline="Hours">
      <div className="mt-1.5 flex flex-col justify-between gap-1 font-body lg:text-lg">
        {formatStoreHours(store.openingHours).map((day) => (
          <div
            className={twMerge(
              "flex justify-between",
              day.dayName === currentDayName && "font-bold"
            )}
            key={day.dayName}
          >
            <p>{day.dayName}</p>
            <div className="mx-1 mb-[7px] flex-1 border-b-2 border-dotted border-b-navy" />
            <p>{day.hours}</p>
          </div>
        ))}
      </div>
    </SPSection>
  );
};

export default SPHoursSection;
